export default __webpack_public_path__ + "static/media/cmo.e624e5fc.png";